import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RpaDescription, RpaDescriptionSectionType } from "@dtm-frontend/shared/ui";
import { I18nService } from "@dtm-frontend/shared/ui/i18n";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { combineLatest, map } from "rxjs";

interface RpaZoneDescriptionComponentState {
    rpaDescription: RpaDescription | undefined;
}

@Component({
    selector: "dtm-map-rpa-zone-description",
    templateUrl: "./rpa-zone-description.component.html",
    styleUrls: ["./rpa-zone-description.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class RpaZoneDescriptionComponent {
    @Input({ required: true }) public set rpaDescription(value: RpaDescription | undefined) {
        this.localStore.patchState({ rpaDescription: value });
    }

    protected readonly sections$ = combineLatest([this.localStore.selectByKey("rpaDescription"), this.i18nService.currentLanguage$]).pipe(
        map(([rpaDescription, language]) => rpaDescription?.sections[language] ?? [])
    );

    protected readonly RpaDescriptionSectionType = RpaDescriptionSectionType;

    constructor(
        private readonly localStore: LocalComponentStore<RpaZoneDescriptionComponentState>,
        private readonly i18nService: I18nService
    ) {
        this.localStore.setState({
            rpaDescription: undefined,
        });
    }
}
